import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "not-found" }

import MdViewer from "@/components/MdViewer.vue";
import codeJson from "@/assets/404.json";
import { IconRight } from "@arco-design/web-vue/es/icon";


export default /*@__PURE__*/_defineComponent({
  __name: '404View',
  setup(__props) {

const leftCode = codeJson.filter((item) => item.id % 2 === 0);
const rightCode = codeJson.filter((item) => item.id % 2 !== 0);

return (_ctx: any,_cache: any) => {
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"margin-bottom":"2rem","text-align":"center"} }, [
      _createTextVNode(" 404 Not Found "),
      _createElementVNode("span", { class: "blink" }, "_")
    ], -1)),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftCode), (item) => {
              return (_openBlock(), _createBlock(_component_a_card, {
                key: item.id,
                bordered: false,
                title: item.lang,
                class: "code-card"
              }, {
                extra: _withCtx(() => [
                  _createVNode(_component_a_link, { href: "/" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("To Index")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(IconRight))
                ]),
                default: _withCtx(() => [
                  _createVNode(MdViewer, {
                    value: item.code
                  }, null, 8, ["value"])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightCode), (item) => {
              return (_openBlock(), _createBlock(_component_a_card, {
                key: item.id,
                bordered: false,
                title: item.lang,
                class: "code-card"
              }, {
                extra: _withCtx(() => [
                  _createVNode(_component_a_link, { href: "/" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("To Index")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(IconRight))
                ]),
                default: _withCtx(() => [
                  _createVNode(MdViewer, {
                    value: item.code
                  }, null, 8, ["value"])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})